import { combineReducers } from "redux";
import authentication from './authentication/reducers';
import data from './data/reducers';
import cart from './cart/reducers';
import management from './management/reducers';

export default combineReducers({
	data,
	authentication,
	cart,
	management
})
